import type {ResizeEventData} from '@gongxigames/framework/core/types';
import {StrictEventEmitter} from '@gongxigames/framework/core/services/strictEventEmitter';
import {WaitingEvents} from '@gongxigames/framework/core/globals/strictCoreEmitter/WaitingEvents';

export type StrictCoreEvents = WaitingEvents & {
    /**
     * Executed before any render logic.
     * Well be emitted even page app is paused
     * Good for: Window resize actions...
     */
    'CORE.renderLoop.tick': void;
    'CORE.renderLoop.beforeRender': void;

    'CORE.input.keydown': KeyboardEvent;
    'CORE.input.keyup': KeyboardEvent;

    'CORE.screen.resize': ResizeEventData;

    'General.ResourcesLoading.LOADED_ALL_RESOURCES': void;
};

export const strictCoreEmitter = new StrictEventEmitter<StrictCoreEvents>();